import { useMutation } from '..';
import { newService2PortfolioMutation } from '../mutations';

export function useNewServiceToPortfolioMutation() {
  const { data, isLoading, mutate } = useMutation();
  const mutateNewService2Portfolio = (variables) => {
    mutate(newService2PortfolioMutation, variables);
  };
  return { data, isLoading, mutateNewService2Portfolio };
}
